import {
  SessionStorage,
  decodeJwt,
  isBrowserStorageAvailable,
} from '@iheartjane/utils';
import { add, fromUnixTime, isBefore } from 'date-fns';

import { AuthStorage } from './authStorage';

export const JWT_KEY = 'jwt';

function storeJwt(token: string, headless: boolean) {
  if (headless && isBrowserStorageAvailable()) {
    SessionStorage.set(JWT_KEY, token);
    AuthStorage.remove(JWT_KEY);
  } else {
    AuthStorage.set(JWT_KEY, token);
  }
}

export function setJwt(jwt: string, headless = false) {
  if (jwt) {
    storeJwt(jwt, headless);
  }
}

export function getJwt(): string | null {
  const jwt = AuthStorage.get<string>(JWT_KEY);

  if (!jwt && isBrowserStorageAvailable()) {
    return SessionStorage.get(JWT_KEY);
  }

  return jwt ?? null;
}

export function removeJwt() {
  AuthStorage.remove(JWT_KEY);

  if (isBrowserStorageAvailable()) {
    SessionStorage.remove(JWT_KEY);
  }
}

export const parseToken = (token: string) =>
  token.includes('Bearer') ? token.split('Bearer ')[1] : token;

export const tokenIsExpired = (token: string, msFromNow: number) => {
  const { exp } = decodeJwt<{ exp: number }>(parseToken(token));
  const expiry = fromUnixTime(exp);
  const roughlyNow = add(new Date(), { seconds: msFromNow / 1000 });
  return isBefore(expiry, roughlyNow);
};
